exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-demo-list[data-v-483684fe]{position:relative}.upload-demo-list .demo-upload-list-cover[data-v-483684fe]{display:none;position:absolute;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.6)}.upload-demo-list .demo-upload-list-cover i[data-v-483684fe]{color:#fff}.upload-demo-list:hover .demo-upload-list-cover[data-v-483684fe]{display:block;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}", ""]);

// exports
